import Vue from 'vue'
import VueRouter from 'vue-router'
import Prod from '../views/Pro_menu.vue'
import Home from '../views/Home.vue'
import proCont from '../views/pro_content.vue'
import About from '../views/aboutus.vue'
import News from '../views/news.vue'
import newsCont from '../views/news_content.vue'
import slideShow from '../views/carousel.vue'
import contactUs from '../views/contact.vue'

Vue.use(VueRouter)

const routes = [{
    path: '/prod',
    name: 'pro_menu',
    components: {
        default: Prod
    }

},
{
    path: '/procont/:id',
    name: 'proCont',
    components: {
        // default:proCont
        a: proCont
    }
},
{
    path: '/news',
    name: 'news',
    component: News
},
{
    path: '/newscont/:id',
    name: 'newsContent',
    component: newsCont
},
{
    path: '/',
    redirect: '/home'
},
{
    path: '/home',
    name: 'home',
    components: {
        default: slideShow,
        a: Home
    }
},
{
    path: '/contact',
    name: 'contact',
    components: {
        a: contactUs
    }
},
{
    path: '/about',
    name: 'about',
    components: {
        a: About
    }
},
{
    path: '*',
    components: {
        default: slideShow,
        a: Home
    }
}
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: routes
})

router.beforeEach((to, from, next) => {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    window.pageYOffset = 0
    next()
})

export default router
